// extracted by mini-css-extract-plugin
export default {"button":"style_button__dLRT4","td":"style_td__FUVUo"};